import React from 'react';
import { Dialog } from '@mui/material';

const DisclaimerModal = ({ open, onAccept }) => {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          return;
        }
      }}
    >
      <div className="p-6">
        {/* Header */}
        <div className="flex items-center space-x-3 mb-4">
          <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-gray-900">Important Notice</h2>
        </div>

        {/* Content */}
        <div className="mb-6 space-y-4">
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
            <p className="text-sm text-gray-700 leading-relaxed">
              <strong>CashBot provides information and AI analysis for educational and informational purposes only.</strong>
            </p>
          </div>

          <div className="text-sm text-gray-600 space-y-3">
            <p>Before using CashBot, please understand that:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>
                <strong>Not Financial Advice:</strong> CashBot does not provide personalized financial, investment, tax, or legal advice.
              </li>
              <li>
                <strong>Educational Purpose:</strong> All responses are meant to help you understand your financial data and provide general insights.
              </li>
              <li>
                <strong>Consult Professionals:</strong> For specific financial decisions, please consult with qualified financial advisors, tax professionals, or legal counsel.
              </li>
              <li>
                <strong>AI Limitations:</strong> While CashBot uses advanced AI, it may not always provide accurate or complete information for your specific situation.
              </li>
              <li>
                <strong>Your Responsibility:</strong> You are solely responsible for any financial decisions you make based on information provided.
              </li>
            </ul>
          </div>

          <div className="bg-gray-50 p-4 rounded border border-gray-200">
            <p className="text-xs text-gray-600 italic">
              By clicking “I Understand and Accept”, you acknowledge that you have read and understood this notice and agree to use CashBot for informational purposes only.
              </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex justify-end">
          <button
            onClick={onAccept}
            className="px-6 py-3 bg-btn-primary text-white rounded-lg hover:bg-btn-primary-hover font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-btn-primary focus:ring-offset-2"
          >
            I Understand and Accept
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DisclaimerModal;